import React, { FC, useState } from "react";
import { BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import Modal from "../../global/Modal/Modal";
import SimpleButton from "../../global/SimpleButton/SimpleButton";
import { deleteDataAPI } from "../../services/CRUDServices";

interface DeleteOperationProps {
  title: string;
  itemId?: number;
  route: string;
  handleDeleteActionNewData?: any;
  icon?: React.ReactNode;
  contentText?:string
  loading?:boolean
}
const DeleteOperation: FC<DeleteOperationProps> = ({
  title,
  itemId,
  route,
  handleDeleteActionNewData,
  icon,
  contentText,
  
}): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading,setLoading]=useState(false)
  const deleteHandler = async (id: number) => {
    try {
      setLoading(true)
      await deleteDataAPI(route, itemId);
      toast.success("با موفقیت حذف شد");
      setIsModalOpen(false);
      handleDeleteActionNewData && handleDeleteActionNewData();
      setLoading(false)
    } catch (error) {
      // setIsModalOpen(false);
      toast.error(
        error.response.data.messages[0]?.message ||
          "خطایی در سیتم رخ داده با پشتیبان تماس بگیرید"
      );
      setLoading(false)
    }
  };
  return (
    <>
      <button
        className=" border-none	text-[16px]  w-[20px] h-[20px]"
        onClick={() => setIsModalOpen(!isModalOpen)}
      >
        {icon || <BiTrash size={20} className="w-full h-full	" />}
      </button>
      <Modal visible={isModalOpen} setVisible={setIsModalOpen} title={title}>
        <p className="text-center">{contentText || "آیا از حذف این مورد اطمینان دارید؟"}</p>
        <div className="flex w-full justify-center gap-4 mt-5">
          <SimpleButton
            type="submit"
            text="خیر"
            className="full-lightTomato-btn w-28 "
            handelClick={() => setIsModalOpen(false)}
          />
          <SimpleButton
            type="submit"
            text="بله"
            className="full-tomato-btn w-28 "
            handelClick={() => deleteHandler(itemId)}
            loading={loading}
          />
        </div>
      </Modal>
    </>
  );
};

export default DeleteOperation;
